export default __webpack_public_path__ + "static/media/email.64be8055.svg";